<template>
<div class="login-wrapper">

  <div class="login-box" style="margin: 0 auto">
     <div class="needs-validation" id="validated-form"> 
    <h3 class="login-box__title">LOGIN</h3>
    <VueButton3 v-if="showErrorMessage"
      class="red fw shadow-none login-box__submit mycursor1"
      title="Plese check your credentials!"
    />
    <v-input ref="input1" placeholder="username" v-model="email"/>
    <!-- <label for="password" v-if="falseEmail" class="myValidationText">Wrong e-mail format!</label> -->
    <label for="password" v-if="emptyEmail" class="myValidationText">Can not be leave empty!</label>
    <span class="text-danger" v-if="validationErrors.email" v-text="validationErrors.email"></span>
    <v-input ref="input2" placeholder="Password" type="password" v-model="password" />
    <label for="password" v-if="emptyPassword" class="myValidationText">Can not be leave empty!</label>
    <router-link class="password-forget" to="/sifremi-unuttum"> I Lost My Password</router-link>
    {{error}}
    <v-button
      class="green fw shadow-none login-box__submit"
      @click.native="getRequestToken"
      title="LOGIN"/>
    <div class="or">
      <p class="or__title">OR</p>
    </div>
    <v-button
      @click.native="gitKayit"
      class="gray fw shadow-none login-box__submit"
      title="REGISTER"
    />
</div>
    <div class="login-box__bottom">
<!--       <p class="login-box__bottom-text">Are You New at HolywoodSkyline.com?</p>

      <router-link to="/kayit-ol" class="button button--more color-light-green" style="color: #5567ab !important;">
        <span class="button__wrp"><span class="button__txt">
              NOW REGISTER
        </span>
          <span class="button__icon"><svg class="icon">
            <use xlink:href="/icon/icons.svg#icon-arrow-long-right"></use></svg></span></span></router-link> -->

      <div>
        <router-link to="/admin-login"
                     class="button button--more color-light-green"><span class="button__wrp">
              <span class="button__txt">
                ADMIN LOGIN
              </span>
          <span class="button__icon">
          <svg class="icon">
            <use xlink:href="/icon/icons.svg#icon-arrow-long-right"></use></svg></span></span></router-link>
      </div>
    </div>
  </div>
  
</div>
</template>

<script>
import * as userApi from '@/api/user'
import { LOGIN, SET_LOGIN1, SET_USER_INFO1 } from '@/store/actions.type'
//import { SET_USER_INFO, SET_TOKEN, SET_LOGIN } from '@/store/mutations.type'
import axios from 'axios'
import VueButton2 from '@/components/VueButton2'
import VueButton3 from '@/components/VueButton3'
export default {
  name: 'Login',
  components: {
    VueButton2, VueButton3
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Login',
      link: [
        { rel: 'canonical', href: window.location.origin + '/user-login/' }
      ]       
    }
  },  
  data: function () {
    return {
      faculties: [],  
      falseEmail: false,
      emptyEmail: false,
      emptyPassword: false,
      showErrorMessage: false,
      token: null,
      session_id: null,
      email: null,
      password: null,
      emailBlured: false,
      valid: false,
      submitted: false,
      error: null,
      validationErrors: {
        firstName: null,
        lastName: null,
        username: null,
        email: null,
        address: null,
        country: null,
        state: null,
          zip: null,
            }      
    }
  },

  methods: {
    gitKayit() {
      this.$router.push('/register')
    },
    selectUniversity (id, faculty_id) {
      // this.university_id = opt.id
      // this.messageForm.university_id = opt.id
      let self = this
      axios.get(`/selected/faculties/${id}`)
        .then(response => {
          self.faculties = response.data
          response.data.forEach((data) => { 
            if(data.id == faculty_id) {
                window.localStorage.setItem('faculty_name', data.name)
            }
            })          
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
      setUniversityName (id, faculty_id) {
      let self = this
      axios.get('/selected/universities')
        .then(response => {
          response.data.forEach((data) => { 
            if(data.id == id) {
                window.localStorage.setItem('university_name', data.name)
                 self.selectUniversity(id, faculty_id)
            }
            })  
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },      
        validateForm () {
            var formId = 'validated-form';
            var nodes = document.querySelectorAll(`#${formId} :invalid`);
            var errorObjectName = 'validationErrors';
            var vm = this; //current vue instance;

            Object.keys(this[errorObjectName]).forEach(key => {
                this[errorObjectName][key] = null
            });

            if (nodes.length > 0) {
                nodes.forEach(node => {
                    this[errorObjectName][node.name] = node.validationMessage;
                    node.addEventListener('change', function (e) {
                        vm.validateForm();
                    });
                });

                return false;
            }
            else {
                return true;
            }
        }, 
    validate: function () {
      this.emailBlured = true
      if (this.validEmail(this.email)) {
        this.valid = true
      }
    },
    validEmail: function (email) {
      let re = /(.+)@(.+){2,}\.(.+){2,}/
      return re.test(email.toLowerCase())
    },
/*     submitForm () {
      userApi.login(this.email, this.password)
        .then((response) => {
          console.log(response)
          if (response.status === 201) {
            this.$router.push({ name: 'Login' })
          }
        })
        .catch(e => {
          console.log(e)
        })
    }, */
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    getRequestToken() {
      var self = this
      axios.get(`/3/authentication/token/new?api_key=a11ac97c6bdb99adc0845654be0902a8`)
          .then(response => {
            if (response.status === 200 || response.status === 201)  {
            self.token = response.data.request_token
            self.login()
            }
          })
        .catch(error => {
          if (error.response) {
            this.showErrorMessage = true
            // console.log('hata: ' + error.response);
        }})
    },
    getSessionId() {
      var self = this
        axios.post(`/3/authentication/session/new?api_key=a11ac97c6bdb99adc0845654be0902a8`, {
        request_token: this.token
        })
        .then(response => {
            if (response.status === 200 || response.status === 201)  {
               self.showSuccessMessage = true

               const user = {first_name: 'rastek', last_name: '',  isLogin: 'true'}

              // self.commit(SET_USER_INFO, response.data.user)
              //self.$store.commit(SET_USER_INFO, user)
            //  self.$store.commit(SET_LOGIN, 'true')

            this.$store.dispatch(SET_USER_INFO1, user)

            this.$store.dispatch(SET_LOGIN1, "true")


              self.session_id = response.data.session_id
              window.localStorage.setItem('session_id', response.data.session_id)      
              window.localStorage.setItem('isLogin', 'true')
              window.localStorage.setItem('first_name1', this.email)
              window.localStorage.setItem('last_name1', '')
              window.localStorage.setItem('university_id1', 100)
              window.localStorage.setItem('faculty_id1', 100)
              window.localStorage.setItem('university_name1', 'Boston College')
              window.localStorage.setItem('faculty_name1', 'Art of History')
              window.localStorage.setItem('type_id', 2)
              window.localStorage.setItem('isLogin', 'true')
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + self.token

              // self.$router.push('/')

              const route = { name: 'Home'}
              this.$router.push(route)

              // self.$store.commit(SET_USER_INFO, response.data)
            }
          })
        .catch(error => {
          if (error.response) {
            this.showErrorMessage = true
            // console.log('hata: ' + error.response);
        }})               
    },
    login () {

      this.falseEmail = false
      this.emptyPassword = false
      this.emptyEmail = false
      const verifiedMail = this.validateEmail(this.email)
      if(!this.password) {
      this.emptyPassword = true
      }
      if(!this.email) {
        this.emptyEmail = true
      } /*else if(this.email && !verifiedMail) {
        this.falseEmail = true
      }*/

      if(this.email && this.password)  {

/*       if (this.validateForm()) {
                console.log('formValidated');
                //submit form to backend
            } */

      // this.validate()
      var self = this
      if(!this.valid) {
        // this.email = 'Mail giriniz'
        this.$refs.input1.value = 'Mail giriniz'
      }
      // if(this.valid) {
        const dene = this.token
        axios.post(`/3/authentication/token/validate_with_login?api_key=a11ac97c6bdb99adc0845654be0902a8`, {
          username: this.email,
          password: this.password,
          request_token: this.token
        })
          .then(response => {
            if (response.status === 200 || response.status === 201)  {
              // self.showSuccessMessage = true
              // self.commit(SET_USER_INFO, response.data.user)
              //self.$store.commit(SET_USER_INFO, response.data)
              //self.token = session.data.request_token
              self.getSessionId()
              /*
              const data = { updateLogin: true, isLogin: 'true' }
              self.$store.commit(SET_USER_INFO, data )
              self.$store.commit(SET_TOKEN, response.data.token )
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token
              self.$router.push('/')
              window.localStorage.setItem('isLogin', 'true')

              window.localStorage.setItem('type_id', response.data.user.type_id)
              window.localStorage.setItem('first_name1', response.data.user.first_name)
              window.localStorage.setItem('last_name1', response.data.user.last_name)
              window.localStorage.setItem('username', response.data.user.first_name + ' ' + response.data.user.last_name)
              
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail1', response.data.user.email)
              window.localStorage.setItem('phone1', response.data.user.phone)
              window.localStorage.setItem('pwd', this.password)
   
              if (response.data.user.university_id) {
                window.localStorage.setItem('university_id1', response.data.user.university_id)
              } else {
                window.localStorage.setItem('university_id1', '')
              }
              if (response.data.user.faculty_id) {
                window.localStorage.setItem('faculty_id1', response.data.user.faculty_id)
              } else {
                window.localStorage.setItem('faculty_id1', '')
              }

              if (response.data.user.university_name) {
                window.localStorage.setItem('university_name1', response.data.user.university_name)
              } else {
                window.localStorage.setItem('university_name1', '')
              }
              if (response.data.user.faculty_id) {
                window.localStorage.setItem('faculty_name1', response.data.user.faculty_name)
              } else {
                window.localStorage.setItem('faculty_name1', '')
              }

              */
              
/*               if(response.data.user.university_name && response.data.user.faculty_name) {               
              } else {
                self.setUniversityName(response.data.user.university_id, response.data.user.faculty_id)
              } */
              
              // document.cookie = "username=response.data.user.first_name; expires=Thu, 18 Dec 2019 12:00:00 UTC";
            } else {
              this.showErrorMessage = true
            }
          })
        .catch(error => {
          if (error.response) {
            this.showErrorMessage = true
            // console.log('hata: ' + error.response);
        }})
      // }
/*       axios.post(`/user/login`, {
        data: {
          email: this.email,
          password: this.password
        } 
      })
         .then(resp => {
          this.$router.push('/')
          console.log(resp)
        })       
      }) */
/* 
      this.$store.dispatch(LOGIN, { email: this.email, password: this.password })
        .then(resp => {
          this.$router.push('/')
          console.log(resp)
        }) */
    }
    }
  },
  mounted() {
/*     var self = this
   this.$refs.input1.addEventListener('change', function (e) {
                        self.validateForm();
                    }); */
    
/*   this.$refs.input1.addEventListener('input', evt => {
  const value = this.$refs.input1.value

  if (!value) {
    this.$refs.input1.dataset.state = ''
    return
  }

  const trimmed = value.trim()

  if (trimmed) {
    this.$refs.input1.dataset.state = 'valid'
  } else {
    ithis.$refs.input1.dataset.state = 'invalid'
  }
})   */  
  }
}
</script>

<style lang="scss">
@import "../assets/scss/components/login";

/* Show red borders when filled, but invalid */
input[data-state="invalid"] {
  border-color: hsl(0, 76%, 50%);;
}

/* Show green borders when valid */
input[data-state="valid"] {
  border-color: hsl(120, 76%, 50%);
}

  .mycursor1 { 
    cursor: default;
    pointer-events: none;
    }
</style>
